import { render } from "./ReservationCard.vue?vue&type=template&id=4cc66f2c&scoped=true"
import script from "./ReservationCard.vue?vue&type=script&lang=js"
export * from "./ReservationCard.vue?vue&type=script&lang=js"

import "./ReservationCard.vue?vue&type=style&index=0&id=4cc66f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc66f2c"]])

export default __exports__